import * as React from "react";
const SvgDownloadIcon = (props) => (
  <svg width={40} height={40} fill="none">
    <circle cx={20} cy={20} r={20} fill="#FBFBFB" />
    <path
      stroke="#6366F1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 24v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2m-13-6 5 5m0 0 5-5m-5 5V11"
    />
  </svg>
);
export default SvgDownloadIcon;
